"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingHabs = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
class FloatingHabs extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.FLOATING_HABS,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 5,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 2)),
            metadata: {
                cardNumber: '225',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 2 M€ to add 1 Floater to ANY card', (eb) => {
                        eb.megacredits(2).startAction.floaters(1).asterix();
                    }).br;
                    b.vpText('1 VP for every 2nd Floater on this card.');
                }),
                description: 'Requires 2 Science tags.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.floaters(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct(player) {
        return player.canAfford(2);
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    action(player) {
        const floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        if (floaterCards.length === 1) {
            player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 2, { title: 'Select how to pay for Floating Habs action' }));
            player.addResourceTo(floaterCards[0], { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Spend 2 M€ and select card to add 1 floater', 'Add floater', floaterCards, (foundCards) => {
            player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 2, { title: 'Select how to pay for Floating Habs action' }));
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
}
exports.FloatingHabs = FloatingHabs;
//# sourceMappingURL=FloatingHabs.js.map